<template>
  <v-card width="1000" class="mx-auto mt-5">
      <v-app-bar color="primary" dark>
        <v-toolbar-title>FAQ</v-toolbar-title>
      </v-app-bar>
    <v-expansion-panels accordion>
      <v-expansion-panel v-for="question in questions" :key="question">
        <v-expansion-panel-header>{{
          question.title
        }}</v-expansion-panel-header>
        <v-expansion-panel-content
          ><span style="color:#808080">{{
            question.content
          }}</span></v-expansion-panel-content
        >
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header style="color:red"><span >退会する</span></v-expansion-panel-header>
        <v-expansion-panel-content
          ><v-alert prominent type="error">
            <v-row align="center">
              <v-col class="grow">本当に退会しますか？</v-col>
              <v-col class="shrink">
                <v-btn @click="withdraw()">退会する</v-btn>
              </v-col>
            </v-row>
          </v-alert></v-expansion-panel-content
        >
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>

<script>
import { mapActions, mapMutations } from "vuex";

export default {
  data: () => ({
    questions: [
       {
        title: "ユーザー情報を編集する",
        content:
          "ユーザー詳細ページにある「ユーザー情報を編集する」からプロフィールを編集することができます。※ユーザー名等を変更する場合はグーグルアカウントを編集することで変更することができます。",
      },
       {
        title: "マイジョブ（個人）を編集する",
        content:
          "マイジョブ一覧画面から「操作」にある鉛筆ボタンを押すことによって編集することが可能です。※実施スケジュールは変更することができません。",
      },
        {
          title: "グループのリーダーが変わるタイミングは？",
          content:
            "各グループのグループリーダーが「グループを脱退」するまたは本アプリを「退会」した場合にグループリーダーの次にグループに参加したユーザーに引き継がれます。",
        },
      {
        title: "所属しているグループのグループジョブに参加したい",
        content:
          "グループジョブ詳細画面から参加することが可能です　※グループジョブ詳細画面はグループジョブ一覧から遷移することが可能です。",
      },
      {
        title: "グループジョブを作成するには？",
        content:
          "グループジョブはグループリーダーのみ作成することはできます。そのためグループジョブを作成したい場合は、グループ詳細画面のチャット機能を使用しグループリーダーにグループジョブを作成する旨を伝えていただくか新たにグループを作成しグループリーダーになっていただくことでグループジョブを作成する事が可能です。",
      },
      {
        title: "グループジョブ作成における開始日と終了日",
        content:
          "グループジョブは開始日から終了日まで最低一ヶ月の期間を設けていただきます。そのため作成する際は一ヶ月以上の期間を設けない場合再設定していただく必要があります",
      },
    ],
  }),

  methods: {
    ...mapActions("user", ["deleteUser"]),
    ...mapMutations(["job/resetMyJobs", "record/resetTimeLine"]),
    // 退会します
    withdraw() {
      if (confirm("退会をしてしまいますとお持ちのデータが全て削除されます。\n本当によろしいですか？")) {
        this["job/resetMyJobs"]()
        this["record/resetTimeLine"]();
        this.deleteUser();
      }
    },
  },
};
</script>
